export const hospitalPostedChargesCategoriesColumns = [
  'id',
  'r1_id',
  'revint_id',
  'apc_payment',
  'category_id',
  'category_name',
  'si',
  'transaction_id',
];
